import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
function render() {
    const container = document.getElementById('root');
    if (!container)
        return;
    createRoot(container).render(_jsx(App, {}));
}
function renderFatal(message) {
    const container = document.getElementById('root');
    if (!container)
        return;
    container.innerHTML = `
    <div style="padding:16px;font-family:'Segoe UI',sans-serif;color:#374151">
      <h2 style="margin-top:0">top.legal couldn't start</h2>
      <p>${message}</p>
      <p style="font-size:12px;color:#6b7280">Try closing and reopening the add-in, or contact <a href="https://top.legal">top.legal support</a>.</p>
    </div>`;
}
// Office.js may fail to load on slow networks or in unsupported browsers.
// Don't leave the user staring at a blank pane — render a helpful message instead.
let rendered = false;
const timeout = setTimeout(() => {
    if (!rendered)
        renderFatal('The Office add-in framework took too long to load. This usually means your browser or Outlook version is not fully supported.');
}, 8000);
try {
    if (typeof Office !== 'undefined' && Office.onReady) {
        Office.onReady(() => {
            clearTimeout(timeout);
            rendered = true;
            render();
        });
    }
    else {
        clearTimeout(timeout);
        renderFatal('The Office add-in framework (Office.js) could not be loaded.');
    }
}
catch (e) {
    clearTimeout(timeout);
    renderFatal(e.message || 'Unexpected error while starting the add-in.');
}
